function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M107.743,84.5h-4.268a1.067,1.067,0,1,1,0-2.134h4.268a3.2,3.2,0,0,0,3.2-3.2V55.695a3.2,3.2,0,0,0-3.2-3.2H69.335a3.2,3.2,0,0,0-3.2,3.2V79.167a3.2,3.2,0,0,0,3.2,3.2H73.6a1.067,1.067,0,1,1,0,2.134H69.335A5.342,5.342,0,0,1,64,79.167V55.695a5.342,5.342,0,0,1,5.335-5.335h38.409a5.342,5.342,0,0,1,5.335,5.335V79.167A5.342,5.342,0,0,1,107.743,84.5Z",
  transform: "translate(-64 -50.36)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M126.936,107.975a5.54,5.54,0,0,1-3.25-1.054l-16.58-11.973a1.067,1.067,0,1,1,1.25-1.728l16.58,11.973a3.371,3.371,0,0,0,4,0l16.58-11.973a1.067,1.067,0,1,1,1.25,1.728l-16.58,11.973A5.536,5.536,0,0,1,126.936,107.975Z",
  transform: "translate(-102.397 -88.749)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M107.728,233.844a1.066,1.066,0,0,1-.755-1.82l10.669-10.669a1.067,1.067,0,1,1,1.509,1.509l-10.669,10.669A1.063,1.063,0,0,1,107.728,233.844Z",
  transform: "translate(-102.394 -203.971)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M395.732,233.844a1.072,1.072,0,0,1-.755-.312l-10.669-10.669a1.067,1.067,0,0,1,1.509-1.509l10.669,10.669a1.066,1.066,0,0,1-.753,1.82Z",
  transform: "translate(-351.988 -203.971)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M203.736,308.5a11.736,11.736,0,1,1,11.736-11.736,1.067,1.067,0,0,1-2.134,0,9.6,9.6,0,1,0-2.925,6.9A1.067,1.067,0,1,1,211.9,305.2,11.665,11.665,0,0,1,203.736,308.5Z",
  transform: "translate(-179.197 -261.555)",
  fill: "#00abff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M261.335,359.7a5.335,5.335,0,1,1,5.335-5.335A5.342,5.342,0,0,1,261.335,359.7Zm0-8.535a3.2,3.2,0,1,0,3.2,3.2A3.2,3.2,0,0,0,261.335,351.161Z",
  transform: "translate(-236.796 -319.153)",
  fill: "#00abff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M345.6,398.094c-2.672,0-4.268-2-4.268-5.335a1.067,1.067,0,0,1,2.134,0c0,2.123.717,3.2,2.134,3.2,1.6,0,2.134-.807,2.134-3.2a1.067,1.067,0,0,1,2.134,0C349.868,394.079,349.868,398.094,345.6,398.094Z",
  transform: "translate(-313.593 -357.552)",
  fill: "#00abff"
});

function SvgMailEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.078,
    height: 46.944,
    viewBox: "0 0 49.078 46.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailEmailIcon);
export default __webpack_public_path__ + "static/media/mail-email-icon.e98e03ae.svg";
export { ForwardRef as ReactComponent };